import React, { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, DialogActions, SxProps } from '@mui/material';
import { headingFontBold, vars } from '../../../../../Theme';
import { useDispatch, useSelector } from 'react-redux';
import { IAppReduxStore } from '../../../../../redux/store';
import { useParams } from 'react-router-dom';
import { INewAssemblyIndexErrorState, INewAssemblyIndexMainState } from '../NewAssemblyIndexDialog';
import { confirmNewAssemblyIndex } from '../../../../../redux/project/documents/sliceProjectNewAssemblyIndex';

const buttonSx: SxProps = {
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '14px',
    fontFamily: headingFontBold,
    lineHeight: 'normal',
    padding: '9px 12px',
    color: vars.white,
};

export default ({ setShowErrorState, mainState, onClose }: INewAssemblyIndexDialogActionsProps) => {
    const { t } = useTranslation('translations', { keyPrefix: 'newAssemblyIndexDialog' });
    const dispatch: Dispatch<unknown> = useDispatch();

    const { replicaId } = useParams();

    const { loading: loadingInfoDocs } = useSelector(
        (_store: IAppReduxStore) => _store.projectDocuments.info,
    );
    const {
        loading: loadingNewIndexPartialModels,
        confirmNewIndexPartialModels,
        selectedAssemblyId,
    } = useSelector((_store: IAppReduxStore) => _store.projectNewAssemblyIndex);

    const validateInput = () => {
        setShowErrorState({
            selectedPartialModelsError: mainState.selectedPartialModelIds.length === 0,

            nextIndexError: !mainState.nextIndex,
        });
        return mainState.selectedPartialModelIds.length > 0 && mainState.nextIndex;
    };

    const onConfirm = () => {
        if (validateInput()) {
            dispatch(
                confirmNewAssemblyIndex({
                    replicaId,
                    universalId: selectedAssemblyId,
                    partialModelIds: mainState.selectedPartialModelIds,
                    assemblySubject: mainState.subject,
                }),
            );
        }
    };

    return (
        <DialogActions sx={{ px: 3, py: 1, borderTop: `1px solid ${vars.lightGray}` }}>
            <Button
                variant={'text'}
                onClick={onClose}
                sx={{ ...buttonSx, color: vars.font }}
                disabled={
                    loadingInfoDocs ||
                    loadingNewIndexPartialModels ||
                    confirmNewIndexPartialModels.loading
                }
            >
                {t('ctaCancel')}
            </Button>
            <Button
                variant={'contained'}
                onClick={onConfirm}
                sx={buttonSx}
                disabled={
                    mainState.selectedPartialModelIds.length === 0 ||
                    !mainState.nextIndex ||
                    confirmNewIndexPartialModels.loading
                }
            >
                {t(`ctaConfirm`)}
            </Button>
        </DialogActions>
    );
};

interface INewAssemblyIndexDialogActionsProps {
    setShowErrorState: Dispatch<React.SetStateAction<INewAssemblyIndexErrorState>>;
    mainState: INewAssemblyIndexMainState;
    onClose: () => void;
}
